import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { NotificationService } from '../../services/notification';
import { NotificationActions } from './notification.actions';

@Injectable()
export class NotificationEffects {
  showNotification$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          NotificationActions.ShowNotificationSuccess,
          NotificationActions.ShowNotificationInfo,
          NotificationActions.ShowNotificationConfirm
        ),
        tap((action: Action & { payload: string }) => {
          if (action.type === NotificationActions.ShowNotificationSuccess) {
            this.notification.success(action.payload);
            return;
          }

          if (action.type === NotificationActions.ShowNotificationInfo) {
            this.notification.info(action.payload);
            return;
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private notification: NotificationService
  ) {}
}
